import React, { useEffect, useState } from "react";
import { venueService } from "services/venueService";
import { getDatesByStartAndEndDate } from "utils/dateUtil";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { RootState, store } from "store";
import { clearPrice, setEndDateTime, setStartDateTime } from "store/apps/price";
import { errorAlert, successAlert } from "utils/alertHandler";
import { useTranslation } from "react-i18next";

interface Block {
  start_time: string;
  end_time: string;
  event: Object;
  isOccupied: boolean;
}

const BLOCKS_MAX = 96;
const MEDIUM_NUMBER = (BLOCKS_MAX * 2) / 5;

export default function useHomeAvailabilityCalendar() {
  const { startTime, endTime, totalHours, totalPrice } = useSelector((state: RootState) => state.price);
  const user = useSelector((state: RootState) => state.auth.user);

  const { t } = useTranslation();

  const [months, setMonths] = useState<any>({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().add(1, "M").endOf("month").format("YYYY-MM-DD"),
  });

  const [dayGroup, setDayGroup] = useState<any>();
  const [highligtedDates, setHighLightedDates] = useState<any>([
    {
      "react-datepicker__day--highlighted-full": [],
    },
    {
      "react-datepicker__day--highlighted-medium": [],
    },
    {
      "react-datepicker__day--highlighted-light": [],
    },
  ]);
  const [selectedDateBlock, setSelectedDateBlock] = useState<any>();

  const dispatch = useDispatch();

  const _onDayPress = (date: any) => {
    console.log("user : ", user);

    if (!user) {
      errorAlert(t("footer_alert_login"));
      return;
    }

    const day = moment(date).format("YYYY-MM-DD");

    setSelectedDateBlock(dayGroup[day]);
  };

  const _onClearSelectedDate = () => {
    setSelectedDateBlock(null);
  };

  const _onMonthChange = (month: any) => {
    const currentMonth = moment(month);

    const start = currentMonth.startOf("month").format("YYYY-MM-DD");
    const end = currentMonth.add(1, "M").endOf("month").format("YYYY-MM-DD");

    setMonths({
      start: start,
      end: end,
    });
  };

  const _onSelectTimeSlot = (item: any) => {
    if (item.isOccupied) return;

    const { startTime, endTime } = store.getState().price;

    if (startTime && !endTime) {
      const currentEndTime = moment(item.end_time);

      if (currentEndTime.isSameOrBefore(startTime)) {
        dispatch(setStartDateTime(item.start_time));
      } else {
        if (startTime == item.start_time) {
          dispatch(clearPrice());
        } else {
          dispatch(setEndDateTime(item.end_time));
        }
      }
    } else {
      dispatch(setStartDateTime(item.start_time));
    }
  };

  useEffect(() => {
    (async function () {
      const result = await venueService.getVenueSlotBlocks(moment(months.start).format("YYYY-MM-DD 00:00:00"), moment(months.end).format("YYYY-MM-DD 00:00:00"));

      if (!result || result.length < 1) return;

      const dateGroups: any = {};

      result.map((block: Block) => {
        const itemDate: string = moment(block.start_time).format("YYYY-MM-DD");

        if (moment(block.end_time).isBefore(moment())) return;

        const availability = dateGroups[itemDate] ? dateGroups[itemDate]["availability"] : BLOCKS_MAX;
        const target = dateGroups[itemDate] ? dateGroups[itemDate]["slots"] : [];

        target.push(block);

        dateGroups[itemDate] = { slots: target, availability: block.isOccupied ? availability - 1 : availability };
      });

      const tmpHightLights: any = [
        {
          "react-datepicker__day--highlighted-full": [],
        },
        {
          "react-datepicker__day--highlighted-medium": [],
        },
        {
          "react-datepicker__day--highlighted-light": [],
        },
      ];

      Object.keys(dateGroups).map((key) => {
        if (dateGroups[key].availability >= MEDIUM_NUMBER && dateGroups[key].availability < BLOCKS_MAX) {
          tmpHightLights[2]["react-datepicker__day--highlighted-light"]?.push(key);
        }

        if (dateGroups[key].availability <= MEDIUM_NUMBER && dateGroups[key].availability > 0) {
          tmpHightLights[1]["react-datepicker__day--highlighted-medium"]?.push(key);
        }

        if (dateGroups[key].availability == 0) {
          tmpHightLights[0]["react-datepicker__day--highlighted-full"]?.push(key);
        }
      });

      setDayGroup(dateGroups);
      setHighLightedDates(tmpHightLights);
    })();
  }, [months]);

  return { startTime, endTime, totalHours, totalPrice, selectedDateBlock, dayGroup, highligtedDates, _onDayPress, _onClearSelectedDate, _onMonthChange, _onSelectTimeSlot };
}
